import React from 'react'
import { useSelector } from 'react-redux'

export function RecoveryHistory() {
  const { sobrieties } = useSelector(state=>state)
  return (
    <>
      {
        sobrieties.map((sobriety,index)=>(
          <div key={sobriety.id} className="p-4 clickable border-bottom">
            <b>Sobriety #{sobrieties.length - index}</b>
            { !!sobriety.sobriety_date && <div>Sobriety Date: {moment(sobriety.sobriety_date).format("MM/DD/YYYY")}</div> }
            { !!sobriety.relapse_date && <div>Relapse Date: {moment(sobriety.relapse_date).format("MM/DD/YYYY")}</div> }
          </div>
        ))
      }
    </>
    )
}
